'use strict';

module.exports = {
  addClass: require('./addClass'),
  removeClass: require('./removeClass'),
  hasClass: require('./hasClass')
};


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/~/dom-helpers/class/index.js
// module id = 881
// module chunks = 0